/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ character: NonNullable<unknown> }} Error_Nav_Illegal_CharactersInputs */

const en_error_nav_illegal_characters = /** @type {(inputs: Error_Nav_Illegal_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plain text contains illegal 608 characters: ${i?.character}`)
};

const fr_error_nav_illegal_characters = /** @type {(inputs: Error_Nav_Illegal_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le texte brut contient des caracteres 608 illegaux : ${i?.character}`)
};

const de_error_nav_illegal_characters = /** @type {(inputs: Error_Nav_Illegal_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der Klartext enthält 608 ungültige Zeichen: ${i?.character}`)
};

const it_error_nav_illegal_characters = /** @type {(inputs: Error_Nav_Illegal_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il testo normale contiene 608 caratteri illegali: ${i?.character}`)
};

const ru_error_nav_illegal_characters = /** @type {(inputs: Error_Nav_Illegal_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`В открытом тексте содержится недопустимое количество символов (608): ${i?.character}`)
};

const es_error_nav_illegal_characters = /** @type {(inputs: Error_Nav_Illegal_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El texto sin formato contiene 608 caracteres ilegales: ${i?.character}`)
};

const zh_cn2_error_nav_illegal_characters = /** @type {(inputs: Error_Nav_Illegal_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`纯文本包含 608 个非法字符：${i?.character}`)
};

const ja_error_nav_illegal_characters = /** @type {(inputs: Error_Nav_Illegal_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プレーンテキストに不正な 608 文字が含まれています: ${i?.character}`)
};

const hi_error_nav_illegal_characters = /** @type {(inputs: Error_Nav_Illegal_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`साधारण पाठ में 608 अवैध अक्षर हैं: ${i?.character}`)
};

const pt_pt2_error_nav_illegal_characters = /** @type {(inputs: Error_Nav_Illegal_CharactersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O texto simples contém 608 caracteres ilegais: ${i?.character}`)
};

/**
* | output |
* | --- |
* | "Plain text contains illegal 608 characters: {character}" |
*
* @param {Error_Nav_Illegal_CharactersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_illegal_characters = /** @type {((inputs: Error_Nav_Illegal_CharactersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Illegal_CharactersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_illegal_characters(inputs)
	if (locale === "de") return de_error_nav_illegal_characters(inputs)
	if (locale === "it") return it_error_nav_illegal_characters(inputs)
	if (locale === "ru") return ru_error_nav_illegal_characters(inputs)
	if (locale === "es") return es_error_nav_illegal_characters(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_illegal_characters(inputs)
	if (locale === "ja") return ja_error_nav_illegal_characters(inputs)
	if (locale === "hi") return hi_error_nav_illegal_characters(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_illegal_characters(inputs)
	return en_error_nav_illegal_characters(inputs)
});